import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllPropertyCoveragesService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [propertyCoveragesSearchQuery, setPropertyCoveragesSearchQuery] =
    useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(
    propertyCoveragesSearchQuery
  );

  const allPropertyCoveragesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.PROPERTY_COVERAGES,
      page,
      per_page,
      debouncedQuery,
    ],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS?.PROPERTY_COVERAGES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    service: { allPropertyCoveragesService },
    states: { propertyCoveragesSearchQuery, setPropertyCoveragesSearchQuery },
  };
};
